import { testimonials, stats } from '@/mocks/home';

export default function TestimonialsSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Stats Row */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mb-20">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center p-6 bg-slate-50 rounded-xl border border-slate-100">
              <p className="text-3xl font-extrabold text-emerald-700 mb-1" style={{ fontFamily: "'Inter', sans-serif" }}>{stat.value}</p>
              <p className="text-slate-500 text-sm">{stat.label}</p>
            </div>
          ))}
        </div>

        {/* Testimonials */}
        <div className="text-center mb-12">
          <span className="text-xs font-semibold uppercase tracking-widest text-emerald-700 mb-3 block">Student Reviews</span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-slate-800" style={{ fontFamily: "'Inter', sans-serif" }}>
            What Students Are Saying
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t) => (
            <div key={t.id} className="bg-white border border-slate-100 rounded-xl p-6 hover:scale-[1.02] transition-transform duration-200" style={{ boxShadow: '0 2px 12px rgba(0,0,0,0.06)' }}>
              <div className="flex items-center gap-0.5 mb-3">
                {Array.from({ length: t.stars }).map((_, i) => (
                  <div key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-amber-400 text-sm"></i>
                  </div>
                ))}
              </div>
              <h3 className="text-slate-800 font-bold text-base mb-2">&ldquo;{t.headline}&rdquo;</h3>
              <p className="text-slate-500 text-sm leading-relaxed mb-5">{t.review}</p>
              <div className="flex items-center gap-3 pt-4 border-t border-slate-100">
                <div className="w-10 h-10 flex-shrink-0 rounded-full overflow-hidden">
                  <img src={t.avatar} alt={t.name} className="w-full h-full object-cover object-top" />
                </div>
                <div>
                  <p className="text-slate-800 font-semibold text-sm">{t.name}</p>
                  <p className="text-slate-400 text-xs">{t.school}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
